import axios from 'axios';
import getWeight from './getWeight';

const fedExEstimateChecker = async (batch) => {
	let err;
	for (let listing of batch.listings) {
		const categories = listing.listing.newSchema.categories || [];
		const subCategories = listing.listing.newSchema.subCategories || [];
		const types = listing.listing.newSchema.types || [];

		const isLightingOrDecor =
			categories.some((i) => i.includes('Lighting')) ||
			categories.some((i) => i.includes('Decor'));
		const isRugOrCarpet =
			subCategories.some((i) => i.includes('Rugs')) ||
			types.some((i) => i.includes('Carpets'));

		if (!isLightingOrDecor || isRugOrCarpet) {
			err = true;
			break;
		}
	}
	if (err) return false;

	const store =
		batch.listings && batch.listings[0].listing.store
			? batch.listings[0].listing.store
			: batch.store;

	if (!store) {
		return true;
	}
	const deliverySettings = store.delivery.deliveryProviders;
	const isFedExEnabled = deliverySettings.fedEx;
	if (!isFedExEnabled) {
		return false;
	}
	const isAll = deliverySettings.fedExAllowedCategory.isAll;
	if (isAll) {
		return true;
	}
	return batch.listings.every((listing) => {
		const category = listing.listing.newSchema.categories[0].toLowerCase();
		const allowedCategory = deliverySettings.fedExAllowedCategory.other.find(
			(catObj) => catObj.name.toLowerCase() === category.toLowerCase()
		);
		return allowedCategory ? allowedCategory.allow : false;
	});
};

const fedExEstimateHandler = async ({ batch, location }) => {
	try {
		let isFedExTrue = await fedExEstimateChecker(batch);

		if (!isFedExTrue) return null;

		let shipperPostCode;
		let recipientPostCode;

		if (batch?.listings[0]?.listing?.delivery?.location?.context) {
			for (let ob of batch.listings[0].listing.delivery.location.context) {
				if (ob.id.includes('postcode')) {
					shipperPostCode = ob.text;
					break;
				}
			}
		}

		if (location?.context) {
			for (let ob of location.context) {
				if (ob.id.includes('postcode')) {
					recipientPostCode = ob.text;
					break;
				}
			}
		}

		let boxes = [];

		let isAllowed = true;
		let serviceType = 'GROUND_HOME_DELIVERY';

		if (batch.listings.length > 0) {
			for (let box of batch.listings) {
				let weight;

				await getWeight(box.listing._id).then((i) => {
					if (i) {
						weight = i;
					}
				});

				if (!weight) {
					weight = 50;
				}
				// }

				if (weight > 150) {
					isAllowed = false;
				} else if (weight > 70) {
					serviceType = 'FEDEX_EXPRESS_SAVER';
				}

				let obj = {
					subPackagingType: 'BOX',
					weight: {
						units: 'LB',
						value: weight ? weight : '20',
					},
					contentRecord: [
						{
							itemNumber: box.listing.SKU ? box.listing.SKU : box.listing._id,
							receivedQuantity: box.quantity,
							description: box.listing.title,
						},
					],
					declaredValue: {
						amount: box.listingPrice,
						currency: 'USD',
					},
				};

				if (
					box.listing.measurements?.H &&
					box.listing.measurements?.D &&
					box.listing.measurements?.L
				) {
					obj.dimensions = {
						length: box.listing.measurements.L,
						width: box.listing.measurements.D,
						height: box.listing.measurements.H,
						units: 'IN',
					};
				}

				boxes.push(obj);
			}
		}

		// If weight for any batch item is grater than 150 we cannot use FedEx ground or Express
		if (!isAllowed) return;

		let payload = {
			requestedShipment: {
				shipper: {
					//seller
					address: {
						postalCode: shipperPostCode,
						countryCode: 'US',
					},
				},
				recipient: {
					//buyer
					address: {
						postalCode: recipientPostCode,
						residential: true,
						countryCode: 'US',
					},
				},
				serviceType,
				preferredCurrency: 'USD',
				rateRequestType: ['ACCOUNT', 'LIST'],
				// pickupType: 'USE_SCHEDULED_PICKUP',
				pickupType: 'DROPOFF_AT_FEDEX_LOCATION',
				requestedPackageLineItems: boxes,
			},
			carrierCodes: ['FDXE', 'FDXG'],
		};

		return await axios
			.post(`${process.env.NEXT_PUBLIC_SERVER_API}/api/fedex/getRate`, payload)
			.then((res) => {
				return res.data;
			})
			.catch((error) => {
				console.log(error);
				return null;
			});
	} catch (error) {
		console.log(error);
		return null;
	}
};
export default fedExEstimateHandler;
